import {useIntl} from 'react-intl';
import {ReactComponent as Arrow} from 'assets/icons/arrow-down.svg';
import {ReactComponent as DoubleChevron} from 'assets/icons/double-chevron.svg';

const SortSelect = ({settings, onChange}) => {
  const intl = useIntl();
  const {
    name,
    label,
    placeholder,
    options,
    state,
  } = settings || {};

  if (!name || !options) {
    return '';
  }

  const Icon = process.env.REACT_APP_SITE === 'ies' ? <DoubleChevron /> : <Arrow />;

  return (
    <div className="select-small flex gap-x-4">
      {label && <span>{intl.formatMessage({id: label})}:</span>}
      <select name={name} onChange={onChange} placeholder={placeholder} value={state[name]}>
        {
          options.map((option) => {
            return <option value={option.value}>
              {intl.formatMessage({id: option.label})}
            </option>
          })
        }
      </select>
      {Icon}
    </div>
  );
};

export default SortSelect;
